@use 'common' as *;

.root {
  z-index: z('popover');
  box-sizing: border-box;
  background: var(--dixa-color-neutral-000);
  border-radius: var(--dixa-size-border-radius-100);
  border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);
  box-shadow: var(--dixa-effect-box-shadow-300);
  margin: var(--dixa-size-spacer-200);
}

.buttonWrapper {
  height: 19px;
}
